<template>
  <div class="container">
    <van-nav-bar title="提交单据" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="menu">
      <van-field readonly label="抄表项目：" :value="communityName" />
      <van-field readonly label="抄表时间：" :value="time" />
    </div>
    <div class="mg12">
      <van-field center readonly label="电费确认：" placeholder="" />
    </div>
    
    <div class="listbox">
      <van-row>
        <van-col span="6">电表编号</van-col>
        <van-col span="6">本期电量</van-col>
        <van-col span="6">基础电价</van-col>
        <van-col span="6">本期电费</van-col>
      </van-row>
      <van-row :key="index" v-for="(item,index) in meterList">
        <van-col span="6">{{item.meterNum}}</van-col>
        <van-col span="6">{{item.totalDegree}}</van-col>
        <van-col span="6">{{item.basicPrice}}</van-col>
        <van-col span="6">{{item.totalAmount}}</van-col>
      </van-row>
      <van-row>
        <van-col span="6">统计</van-col>
        <van-col span="6">{{totalDegree.toFixed(2)}}</van-col>
        <van-col span="6"></van-col>
        <van-col span="6">￥{{totalAmount.toFixed(2)}}</van-col>
      </van-row>
    </div>

    <div class="mg12">
      <van-field center readonly label="缴费单据：" placeholder="" />

      <div class="upImgBox">
        <van-uploader
          v-model="imgList"
          :max-size="10485760"
          :before-read="beforeRead"
          :before-delete="delImg"
        />
      </div>
    </div>

    <div class="botBox clearfix">
      <div class="fl_left">
        <span class="lab">单据数量</span>
        <span class="val col_b">{{upImgList.length}}</span>
      </div>
      <div class="fl_right">
        <van-button round type="info" @click="upCheckList" :disabled="upImgList.length == 0">提交单据</van-button>
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {uploadFiles} from '@/upload.js';
  import ImageCompressor from 'image-compressor.js' //js图片压缩旋转库
  import {NavBar,Icon,Image,Toast,Button,Field,Col,Row,Uploader} from 'vant';
  export default {
    data() {
      return {
        id: '',
        communityName: '',
        time:'',
        totalDegree:0,
        totalAmount:0,
        meterList:[],
        imgList:[],
        upImgList:[],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Col.name]:Col,
      [Row.name]:Row,
      [Uploader.name]:Uploader,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html",query:{active:0,communityName:this.communityName,fileNum:this.upImgList.length}});
      },
      beforeRead(file) {
        var that = this;
        if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png' && file.type !== 'image/bmp') {
          Toast('请上传 jpg jpeg png bmp 格式图片');
          return false;
        } else if (file.size > 10485760 ) {
          Toast('请上传不大于 10M 的图片');
          return false;
        } else{
          new ImageCompressor(file, {
            quality: 0.6, //压缩质量
            checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
            success(result) {
              //压缩后的文件会自动转换成二进制文件流类型
              //这里可以发ajax，上传图片
              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '图片上传中...'
              });
              that.uprightSuc(result.name,result);
            }
          })
          return true;
        }
        
      },
      delImg(item,index){
        console.log(index)
        this.upImgList.splice(index, 1);
        console.log(this.upImgList)
        return true;
      },
      uprightSuc(imgName, imgFile) {
          let _this = this;
          uploadFiles(imgName, imgFile)         
          .then(function (result) {
            _this.upImgList.push(result.name);
            Toast.clear();
          })
          .catch(function (err) {
            console.log('err', err)
          })
      },
      getMeterInfo() {
        axios.get("/meteruploaddegree/getmeteruploaddegree?id="+this.id).then((res)=>{
          if(res.data){
            this.meterList = res.data.meterUseList;
            this.communityId = res.data.communityId;
            this.communityName = res.data.communityName;
            this.time = res.data.endTime;
            this.meterList.forEach(item=>{
              this.totalDegree += item.totalDegree;
              this.totalAmount += item.totalAmount;
            })
          }
        })
      },
      upCheckList() {
        //上传
        // Toast.loading({
        //   duration: 0,       // 持续展示 toast
        //   forbidClick: true, // 禁用背景点击
        //   loadingType: 'spinner',
        //   message: '提交中...'
        // });
        if(this.upImgList.length == 0){
          Toast('请上传缴费单据');
          return
        }
        axios.post("/meteruploaddegree/updatecertificate",{
          id: this.id,
          certificateImageList: this.upImgList,
        }).then((res)=>{
          if(res.isSuccess){
            Toast('提交成功');
            setTimeout(()=>{
              this.changePage('uploadResult');
            },1500)
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.id = this.$route.query.id;
      this.getMeterInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 100px;
  }
  
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    .van-row{
      border-bottom: 1px solid #F0F4F7;
    }
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .botBox{
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 12px;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
    .lab{
      margin-right: 10px;
    }
    .van-button{
      width: 170px;
      line-height: 60px;
    }
  }
  .mg12{margin-top: 12px;}
  .upImgBox{
    background: #fff;
    padding: 12px 18px;
    .van-uploader__upload{width: 60px !important;height: 60px !important;}
  }
</style>
